var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBorderTopRight = function SvgBorderTopRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 360,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M165 65.5v294M164.5 50.5V31c0-16.569-13.431-30-30-30H0",
    stroke: "#000"
  })));
};

export default SvgBorderTopRight;